import { createContext } from "react";

export type ToastTone = "profit" | "loss";

export interface ToastInput {
  tone: ToastTone;
  title: string;
  meta?: string | undefined;
}

export interface ToastApi {
  show: (toast: ToastInput) => void;
}

/**
 * Контекст вынесен из `Toast.tsx` отдельным модулем: файл, экспортирующий и
 * компоненты, и не-компоненты, ломает Fast Refresh — правка провайдера
 * перезагружала бы страницу целиком вместо горячей замены.
 */
export const ToastContext = createContext<ToastApi | null>(null);
